// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__d3OsM","item":"PaymentsMobile_item__1JQY7","label":"PaymentsMobile_label__1r15H","amount":"PaymentsMobile_amount__1b85L"};